import React, { useEffect, useRef, useState } from "react";
import { Button } from "@foundit/ui-library";
import {
  getKnowledgeHubUrl,
  leftSectionOptions,
  leftSectionOptionsLO,
} from "../utils/headerUtils";
import { IMenuOption, MenuDropdown } from "./Dropdown";
import MobileMenu from "./MobileMenu";
import MenuIcon from "../icons/MenuIcon";
import { extractDomain } from "../utils/utils";

interface IProps {
  userData: any;
  showBetaTag?: boolean;
  isMobileViewEnabled?: boolean;
  isRevamp?: boolean;
  isLoggedIn?: boolean;
}

const LeftSection: React.FC<IProps> = ({
  userData,
  showBetaTag,
  isMobileViewEnabled,
  isRevamp,
  isLoggedIn,
}) => {
  const refs = useRef<Record<string, HTMLDivElement | null>>({});

  const [openMenu, setOpenMenu] = useState<string | null>(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isNewFmEnabled, setIsNewFmEnabled] = useState(false);

  const url = `${extractDomain()}/edge/recruiter-dashboard/`;
  const mobileViewEnabled = !isLoggedIn && isMobileViewEnabled;

  const updatedLeftSectionOptions = leftSectionOptions.map((section) => {
    let finalData = { ...section };

    if (section.label === "Folders") {
      finalData = {
        ...section,
        url: isNewFmEnabled
          ? `${extractDomain()}/edge/recruiter-fm/manage-folder`
          : `${extractDomain()}/edge/foldermanagement/manage-folder`,
      };
    }
    return finalData;
  });

  const options = isLoggedIn ? updatedLeftSectionOptions : leftSectionOptionsLO;

  const handleMenuOpen = (label: string) => {
    setOpenMenu((prev) => (prev === label || !label ? null : label));
  };

  const handleClose = () => {
    setOpenMenu(null);
  };

  const handleMenuOptionClick = (option: IMenuOption) => {
    if (option.onClick) {
      option.onClick();
    } else if ((option as any).url) {
      if (option?.label?.toLowerCase() === "platform guide") {
        const currentUrl =
          typeof window !== "undefined" ? window.location.href : "";
        window.location.href = getKnowledgeHubUrl(currentUrl);
      } else {
        window.location.href = (option as any).url;
      }
    }
    handleClose();
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const isRevampEnabled =
        localStorage?.getItem("isRevampFmListing") === "true" || false;

      setIsNewFmEnabled(isRevampEnabled);
    }
  }, []);

  return (
    <div className="rec_header_ls_container">
      <div className="rec_header_ls_logo_wrapper">
        {/* Mobile Menu Icon  */}
        {mobileViewEnabled && (
          <div
            className="rec_header_ls mobile_only"
            onClick={(e) => {
              e.stopPropagation();
              setMobileOpen((prev) => !prev);
            }}
          >
            <MenuIcon />
          </div>
        )}

        <a href={url} className="rec_header_ls_logo">
          <div className="RecHeaderSprite icons foundit_logo" />
        </a>

        {showBetaTag && <div className="rec_header_ls_beta_tag">BETA</div>}
      </div>

      {/* Desktop view  */}
      <div
        className={`rec_header_ls_options rec_header_ls ${
          mobileViewEnabled ? "desktop_only" : ""
        }`}
      >
        {options?.map((item, index) => {
          const dropdownOptions: IMenuOption[] = item?.options?.length
            ? item.options?.map((opt) => ({
                label: opt.label,
                onClick: () => (window.location.href = opt.url),
                url: opt.url,
              }))
            : [];

          const hasDropdown = dropdownOptions.length > 0;

          return (
            <div
              key={`header_ls_op_${index}`}
              ref={(el) => {
                refs.current[item.label] = el;
              }}
              className="rec_header_ls_option_wrapper"
              onMouseEnter={() => {
                if (hasDropdown) {
                  handleMenuOpen(item.label);
                }
              }}
              onMouseLeave={() => {
                if (hasDropdown) {
                  handleMenuOpen("");
                }
              }}
            >
              {item.url ? (
                <a
                  href={item.url || ""}
                  className="rec_header_ls_option_link rec_header_ls_links"
                >
                  {item.label}
                </a>
              ) : (
                <Button
                  size="medium"
                  type="text"
                  className="rec_header_ls_links"
                  onClick={() => {
                    if (hasDropdown) {
                      handleMenuOpen(item.label);
                    }
                    //  else if (item.url) {
                    //   window.location.href = item.url;
                    // }
                  }}
                  endIcon={
                    hasDropdown ? (
                      <div
                        className={`RecHeaderSprite icons ${
                          openMenu === item.label ? "up_arrow" : "dwn_arrow"
                        }`}
                      />
                    ) : null
                  }
                >
                  {item.label}
                </Button>
              )}

              {hasDropdown && (
                <MenuDropdown
                  anchorRef={{ current: refs.current[item.label] }}
                  isOpen={openMenu === item.label}
                  onClose={handleClose}
                  options={dropdownOptions}
                  onMenuOptionClick={handleMenuOptionClick}
                />
              )}
            </div>
          );
        })}
      </div>

      {/* Mobile View  */}
      {mobileOpen && mobileViewEnabled && (
        <div
          className="rec_header_ls mobile_only"
          onClick={() => setMobileOpen(false)}
        >
          {/* <div
            className="rec_header_ls_mobile_overlay"
            onClick={() => setMobileOpen(false)}
          > */}
          <div
            className="rec_header_ls_mobile_wrapper"
            onClick={(e) => e.stopPropagation()}
          >
            <MobileMenu
              options={options}
              onClose={() => setMobileOpen(false)}
            />
          </div>
        </div>
        // </div>
      )}
    </div>
  );
};

export default LeftSection;
